export enum ServiceRequestMediaType {
  Image = 'image',
  Video = 'video',
  Text = 'text',
  Pdf = 'pdf',
  Binary = 'binary',
}
